// extracted by mini-css-extract-plugin
module.exports = {"new-password__send":"_2AKb-","new-password":"_12bpJ","title__primary":"_30-xB","title__secondary":"_3iscN","new-password__title":"_2YJ8Y","title":"_3WNdV"};